import React, { useState, useEffect, CSSProperties, useRef } from "react";
import { Table, OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm";
import {
  HISTORY_REPORT_STATUS,
  PICKLIST_GROUP_NAME,
  QME_APPOINTMENT_STATUS,
  EDITOR_REPORT_STATUS,
  ROR_STATUS,
  WEB_ROLE,
} from "./Constant";
import { GetMedicalAssistant } from "../services/StakeholderApi";
import { updateMedicalAssistant } from "../services/ScheduleAppointmentApi";
import { DropdownPortal } from "./DropdownPortal";
import { GetSpecialInstructionData } from "../services/SystemLocationAPI";
import SplInstructionsModal from "./SplInstructionsModal";
import { useSelector } from "react-redux";
import { RootState } from "../redux/Store";
import { fetchPickListByGroupName } from "../services/CaseInformationApi";
import {TRANSCRIPTION_REPORT_STATUS} from "../common/Constant";
interface DataTableProps {
  headers: {
    key: string;
    label: string;
    sortable?: boolean;
    items?: any;
    style?: any;
    isNumeric?: boolean;
  }[];
  rows?: any[];
  onAction?: (action: string, row: any) => void;
  onSortAction?: (row: any, action?: string) => void;
  isLogTable?: boolean;
  selectedRow?: any;
  isCheckbox?: boolean;
  onCheckboxSelect?: (selectedRows: any[]) => void;
  selectedRowIds?: any;
  disabled?: boolean;
  onSaveSuccess: any;
  selectAll?: boolean;
  setSelectAll?: (value: boolean) => void;
  filteredActionOptions: any;
  userRole: string;
  allowCheckBox: any;
  onCaseClick?: any;
}

const AppointmentDataTable: React.FC<DataTableProps> = ({
  headers,
  rows = [],
  onAction,
  onSortAction,
  isLogTable = false,
  isCheckbox = false,
  onCheckboxSelect,
  selectedRowIds = [],
  disabled = false,
  onSaveSuccess,
  selectAll = false,
  setSelectAll = () => { },
  filteredActionOptions,
  userRole,
  allowCheckBox,
  onCaseClick,
}) => {
  const [sortedRows, setSortedRows] = useState<any[]>(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ASC" | "DESC" | null;
  }>({
    key: "",
    direction: null,
  });
  const [openDropdownRowId, setOpenDropdownRowId] = useState<number | null>(
    null,
  );
  const [assignMedicareAssistantOptions, setassignMedicareAssistantOptions] =
    useState<any[]>([]);

  const handleDropdownToggle = async (
    rowId: number,
    row: any,
    isOpen: boolean,
  ) => {
    setOpenDropdownRowId(isOpen ? rowId : null);
    const responseData = await GetMedicalAssistant(row.caseInfoId);
    if (responseData?.isSuccess && Array.isArray(responseData.result)) {
      const formattedOptions = responseData.result.map((item: any) => ({
        value: item.userId,
        label: item.medicalAssistantNames,
      }));
      setassignMedicareAssistantOptions(formattedOptions);
    }
  };

  // useEffect(() => {
  //   if (rows && rows?.length > 0) {
  //     (async () => {
  //       try {
  //         const caseInfoIds = [
  //           ...new Set(rows.map((r) => r.caseInfoId).filter(Boolean)),
  //         ];

  //         const allOptions: any[] = [];

  //         for (const id of caseInfoIds) {
  //           const responseData = await GetMedicalAssistant(id);
  //           if (responseData?.isSuccess && Array.isArray(responseData.result)) {
  //             const formattedOptions = responseData.result.map((item: any) => ({
  //               value: item.userId,
  //               label: item.medicalAssistantNames,
  //             }));
  //             allOptions.push(...formattedOptions);
  //           }
  //         }

  //         // store combined options in state
  //         setassignMedicareAssistantOptions(allOptions);
  //       } catch (err) {
  //         console.error("Error fetching assistants:", err);
  //       }
  //     })();
  //   }
  // }, [rows]);

  const handleMedicalAssistantChange = async (row: any, option: any) => {
    const payload = {
      subjectQmeScheduleIds: String(row.subjectqmescheduleid),
      medicalAssistantId: option,
      notes: "",
    };
    try {
      const response = await updateMedicalAssistant(payload);
      if (response.isSuccess) {
        setFocusedRowId(null);
        setTimeout(() => {
          onSaveSuccess();
        }, 800);
      }
    } catch (error) {
      console.error("Error updating assistant:", error);
    }
  };

  const handleSort = (key: string, direction: "ASC" | "DESC") => {
    if (sortConfig.key === key && sortConfig.direction === direction) {
      return;
    }
    const sorted = [...sortedRows].sort((a, b) => {
      if (direction === "ASC") {
        return a[key] > b[key] ? 1 : -1;
      }
      if (direction === "DESC") {
        return a[key] < b[key] ? 1 : -1;
      }
      return 0;
    });

    setSortedRows(sorted);
    setSortConfig({ key, direction });
    onSortAction?.({ key, direction });
  };

  useEffect(() => {
    if (
      isCheckbox &&
      rows?.length > 0 &&
      selectedRowIds?.length > 0 &&
      Array.isArray(selectedRowIds)
    ) {
      const cleanedIds = selectedRowIds?.map((id: string) => id?.trim());
      const selectedIdSet = new Set(cleanedIds);

      const selected = rows?.filter((row) =>
        selectedIdSet.has(String(row.subjectqmescheduleid)),
      );

      setSortedRows(rows);
      setSelectedRows(selected);
      const allSelected = rows?.length > 0 && selected?.length === rows?.length;
      setSelectAll(allSelected);
    } else {
      setSortedRows(rows || []);
      setSelectedRows([]);
    }
  }, [rows, selectedRowIds]);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    const selectableRows = sortedRows.filter((row) => {
      return row.appointmentStatusDesc !== QME_APPOINTMENT_STATUS.CANCELLED;
    });

    const updated = newSelectAll ? [...selectableRows] : [];

    setSelectAll?.(newSelectAll);
    onCheckboxSelect?.(updated);
  };

  const handleCheckboxChange = (row: any) => {
    const isSelected = selectedRows.some(
      (r) => r.subjectqmescheduleid === row.subjectqmescheduleid,
    );

    const updated = isSelected
      ? selectedRows.filter(
        (r) => r.subjectqmescheduleid !== row.subjectqmescheduleid,
      )
      : [...selectedRows, row];

    setSelectedRows(updated);
    setSelectAll(updated.length === sortedRows.length);
    onCheckboxSelect?.(updated);
  };

  const dropdownRefMap = useRef<{ [key: string]: HTMLElement | null }>({});
  const [focusedRowId, setFocusedRowId] = useState<number | null>(null);
  const [selectedMedicalAssistants, setSelectedMedicalAssistants] = useState<{
    [id: number]: number | null;
  }>({});

  useEffect(() => {
    const initialSelections: { [id: number]: number | null } = {};
    sortedRows.forEach((row) => {
      initialSelections[row.subjectqmescheduleid] =
        row.medicalAssistantId ?? null;
    });
    setSelectedMedicalAssistants(initialSelections);
  }, [sortedRows]);

  const [searchValues, setSearchValues] = useState<{ [id: number]: string }>(
    {},
  );
  const [showModal, setShowModal] = useState(false);
  const [instructionsData, setInstructionsData] = useState<any[]>([]);
  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);

  const userID = useSelector((state: RootState) => state.auth.userid);

  const params = {
    location: {
      groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
      triggerById: userID,
    },
  };

  const fetchCategoryData = async () => {
    try {
      const categoryData = await fetchPickListByGroupName(params.location);

      setInstructionOption(categoryData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (userID) fetchCategoryData();
  }, [userID]);

  const [modalPos, setModalPos] = useState<{
    top: number;
    left?: number;
    right?: number;
  } | null>(null);

  const handleOpenInstructionModal = async (
    medicareID: any,
    e: React.MouseEvent,
  ) => {
    try {
      if (medicareID) {
        const instruction = await GetSpecialInstructionData(medicareID);

        if (Array.isArray(instruction) && instruction.length > 0) {
          const transformed = instruction.map((item: any) => ({
            ...item,
            SplInstructionName: item.splInstructionName,
            SplInstructionData: item.splInstructionData,
          }));

          setInstructionsData(transformed);
        } else {
          const optionTransformed = instructionOption.map((item: any) => ({
            ...item,
            SplInstructionName: item.label,
            SplInstructionData: "-",
          }));

          setInstructionsData(optionTransformed);
        }
      }
    } catch (e) {
      console.error("Invalid JSON for splInstructions", e);
      setInstructionsData([]);
    }

    const rect = (e.target as HTMLElement).getBoundingClientRect();
    const modalWidth = window.innerWidth * 0.5;
    const verticalOffset = 5;
    const horizontalOffset = 18;
    let position: { top: number; left?: number; right?: number };

    if (rect.left < window.innerWidth / 2) {
      position = {
        top: rect.bottom + verticalOffset,
        left: rect.left + horizontalOffset,
      };
    } else {
      position = {
        top: rect.bottom + verticalOffset,
        left: rect.right - modalWidth - horizontalOffset,
      };
    }

    setModalPos(position);
    setShowModal(true);
  };

  const shouldDisableSelectAll =
    sortedRows?.length > 0 &&
    sortedRows.every(
      (row) => row.appointmentStatusDesc == QME_APPOINTMENT_STATUS.CANCELLED,
    );

  let assignMedicalDisable = false;

  if (
    userRole === WEB_ROLE.Case_Manager ||
    userRole === WEB_ROLE.QME_Doctor ||
    userRole === WEB_ROLE.Medical_Assistant
  ) {
    assignMedicalDisable =
      sortedRows?.length > 0 &&
      sortedRows.every(
        (row) =>
          row.appointmentStatusDesc === QME_APPOINTMENT_STATUS.CANCELLED ||
          row.appointmentStatusDesc ===
          QME_APPOINTMENT_STATUS.PATIENT_DENIED_APPOINTMENT ||
          row.appointmentStatusDesc ===
          QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW ||
          row.appointmentStatusDesc === QME_APPOINTMENT_STATUS.QME_NO_SHOW ||
          row.appointmentStatusDesc ===
          QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW ||
          row.appointmentStatusDesc === QME_APPOINTMENT_STATUS.COMPLETED,
      );
  }

  return (
    <>
      <div className="table-responsive border-0 mb-2">
        {/* <Table className="table vieweditdatatable newtab"> */}
        <Table className="table newtab apt static_appointement_table">
          <thead>
            <tr>
              {isCheckbox && sortedRows?.length > 0 && (
                <th style={{ width: "45px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    disabled={shouldDisableSelectAll}
                  />
                </th>
              )}

              {headers.map((header) => (
                <th
                  key={header.key}
                  className="adjust_ma"
                  style={{
                    border: "none",
                    padding: "8px",
                    backgroundColor: "#e0f7fa",
                    color: "#000",
                    cursor: header.sortable ? "pointer" : "default",
                    position: "sticky",
                    top: 0,
                    zIndex: -90,

                    textAlign: "left",
                    ...header.style,
                  }}
                >
                  <div
                    style={{
                      display: "flex",

                      justifyContent: "space-between",

                      alignItems: "center",
                    }}
                  >
                    <span>{header.label}</span>
                    {header.sortable && (
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginLeft: "4px",
                          cursor: "pointer",
                          position: "absolute",
                          right: "0px",
                        }}
                      >
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "ASC"
                        ) && (
                            <span
                              className="material-icons"
                              style={{
                                fontSize: "18px",
                                lineHeight: "10px",
                              }}
                              onClick={() => handleSort(header.key, "ASC")}
                            >
                              arrow_drop_up
                            </span>
                          )}
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "DESC"
                        ) && (
                            <span
                              className="material-icons"
                              style={{
                                fontSize: "18px",
                                lineHeight: "10px",
                              }}
                              onClick={() => handleSort(header.key, "DESC")}
                            >
                              arrow_drop_down
                            </span>
                          )}
                      </span>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedRows?.length > 0 ? (
              sortedRows.map((row, index) => (
                <tr
                  key={row.id}
                  style={{
                    backgroundColor: index % 2 === 1 ? "white" : "#f2f2f2",
                  }}
                >
                  {isCheckbox && (
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={selectedRows.some(
                          (r) =>
                            r.subjectqmescheduleid === row.subjectqmescheduleid,
                        )}
                        onChange={() => handleCheckboxChange(row)}
                        disabled={
                          disabled ||
                          row.appointmentStatusDesc ==
                          QME_APPOINTMENT_STATUS.CANCELLED
                        }
                      />
                    </td>
                  )}

                  {headers.map((header) => {
                    const cellContent = row[header.key];

                    if (header.key === "caseId") {
                      return (
                        <td
                          key={header.key}
                          style={{
                            padding: "8px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <OverlayTrigger
                            placement="auto"
                            delay={{ show: 200, hide: 10 }}
                            overlay={
                              cellContent && cellContent?.length > 15 ? (
                                <Tooltip
                                  id={`tooltip-${header.key}-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  {cellContent}
                                </Tooltip>
                              ) : (
                                <></>
                              )
                            }
                          >
                            <span
                              className="d-inline-block text-truncate"
                              style={{
                                cursor: "pointer",
                                width: "95%",
                                color: "#007bff",
                              }}
                            >
                              <a
                                href="#"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onCaseClick(row);
                                }}
                              >
                                {cellContent}
                              </a>
                            </span>
                          </OverlayTrigger>

                          
                        </td>
                      );
                    }

                    if (header.key === "locations") {
                      return (
                        <td key={header.key}>
                          {row.locations}
                          {row.medicareId ? (
                            <span
                              className="material-symbols-outlined"
                              style={{
                                cursor: "pointer",
                                color: "#f39c12",
                                fontSize: "18px",
                                marginLeft: "8px",
                                verticalAlign: "middle",
                              }}
                              onClick={(e) =>
                                handleOpenInstructionModal(row.medicareId, e)
                              }
                            >
                              info
                            </span>
                          ) : null}
                        </td>
                      );
                    }

                    const isStatusColumn =
                      header.key === "appointmentStatusDesc" ||
                      header.key === "historyStatus" ||
                      header.key === "editorStatus" ||
                       header.key === "transcriberStatusDesc" ||
                      header.key === "rorStatus";

                    const getStatusColor = (status: string) => {
                      switch (status) {
                        case QME_APPOINTMENT_STATUS.CANCELLED:
                        case QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW:
                        case QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW:
                        case QME_APPOINTMENT_STATUS.QME_NO_SHOW:
                        case QME_APPOINTMENT_STATUS.PATIENT_DENIED_APPOINTMENT:
                        case HISTORY_REPORT_STATUS.NOT_SCHEDULED:
                        case HISTORY_REPORT_STATUS.CANCELLED:
                        case HISTORY_REPORT_STATUS.OVERDUE:
                        case ROR_STATUS.NOT_INITIATED:
                        case ROR_STATUS.Cancelled_Appointment:
                          return "#FF0000";
                        case QME_APPOINTMENT_STATUS.SCHEDULED:
                        case HISTORY_REPORT_STATUS.PENDING:
                        case HISTORY_REPORT_STATUS.SCHEDULED:
                        case ROR_STATUS.IN_REVIEW:
                          return "#0092d5";
                        case QME_APPOINTMENT_STATUS.PATIENT_CHECKED_IN:
                          return "#49B2B2";
                        case QME_APPOINTMENT_STATUS.COMPLETED:
                        case HISTORY_REPORT_STATUS.COMPLETED:
                        case ROR_STATUS.REVIEW_COMPLETED:
                        case ROR_STATUS.Review_Completed_Delayed:
                          return "#0E8536";

                        case QME_APPOINTMENT_STATUS.RESCHEDULED:
                        case QME_APPOINTMENT_STATUS.QME_REQUESTED_CANCELLATION:
                        case QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE:
                        case HISTORY_REPORT_STATUS.DRAFT:
                        case ROR_STATUS.DRAFT_REVIEW:
                          return "#fcaa13ff";
                        case EDITOR_REPORT_STATUS.OVERDUE:
                        case EDITOR_REPORT_STATUS.EDITING_NOT_INITIATED:
                          return "#FF0000";
                        case EDITOR_REPORT_STATUS.PENDING_DOCTOR_APPROVAL:
                          return "#0092d5";
                        case EDITOR_REPORT_STATUS.EDITING_PENDING:
                          return "#197a72ff";
                        case EDITOR_REPORT_STATUS.EDITING_IN_PROGRESS:
                          return "#ff9a17ff";
                        case EDITOR_REPORT_STATUS.SENT_FOR_REWORK:
                          return "#3a17ffff";
                        case EDITOR_REPORT_STATUS.APPROVED_BY_DOCTOR:
                          return "#025f3bff";
                        case EDITOR_REPORT_STATUS.COMPLETED:
                        case QME_APPOINTMENT_STATUS.COMPLETED:
                          return "#0E8536";
  case TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_NOT_INITIATED:
                          return "#fa0808ff";
                        case TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_COMPLETED:
                          return "#0E8536";
                        case TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_IN_PROGRESS:
                          return "#fcaa13ff";
                        case TRANSCRIPTION_REPORT_STATUS.EXCEPTION:
                          return "#fc7013ff";
                        case TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_PENDING:
                          return "#197a72ff";

                        default:
                          return "#000000";
                      }
                    };

                    return (
                      <td
                        key={header.key}
                        style={{
                          padding: header.isNumeric
                            ? "8px 20px 8px 8px !important"
                            : "8px",
                          textAlign: header.isNumeric ? "center" : "left",
                        }}
                      >

                        {header.key === "medicalAssistant" ? (
                          <>
                            <input
                              type="text"
                              className={
                                focusedRowId === row.subjectqmescheduleid
                                  ? ""
                                  : "appointment_input"
                              }
                              disabled={
                                !allowCheckBox ||
                                assignMedicalDisable ||
                                new Date(row.startTime).setHours(0, 0, 0, 0) <
                                new Date().setHours(0, 0, 0, 0)
                              }
                              value={
                                searchValues[row.subjectqmescheduleid] !==
                                  undefined
                                  ? searchValues[row.subjectqmescheduleid] ||
                                  row.medicalAssistant ||
                                  "Select"
                                  : row.medicalAssistant || "Select"
                              }
                              ref={(el) => {
                                if (
                                  openDropdownRowId === row.subjectqmescheduleid
                                ) {
                                  dropdownRefMap.current[
                                    row.subjectqmescheduleid
                                  ] = el;
                                }
                              }}
                              style={{
                                cursor: "pointer",
                                color: "#000",
                                backgroundColor: "transparent",
                                border: "1px solid #ced4da",
                                borderRadius: "4px",
                                padding: "4px 8px",
                                width: "100%",
                                background: "#fff",
                              }}
                              onClick={() => {
                                if (
                                  row.appointmentStatusDesc === "Cancelled" ||
                                  new Date(row.startTime).setHours(0, 0, 0, 0) <
                                  new Date().setHours(0, 0, 0, 0)
                                )
                                  return;
                                setFocusedRowId(row.subjectqmescheduleid);
                                handleDropdownToggle(
                                  row.subjectqmescheduleid,
                                  row,
                                  openDropdownRowId !==
                                  row.subjectqmescheduleid,
                                );
                              }}
                              onChange={(e) => {
                                const typed = e.target.value;
                                setSearchValues((prev) => ({
                                  ...prev,
                                  [row.subjectqmescheduleid]: typed,
                                }));
                              }}
                            />

                            {focusedRowId === row.subjectqmescheduleid && (
                              <span className="arrowpointer_appoitnment">
                                &nbsp;
                              </span>
                            )}
                            <DropdownPortal
                              visible={
                                openDropdownRowId === row.subjectqmescheduleid
                              }
                              targetRef={{
                                current:
                                  dropdownRefMap.current[
                                  row.subjectqmescheduleid
                                  ] || null,
                              }}
                              onClose={() => {
                                setOpenDropdownRowId(null);
                                setSearchValues((prev) => ({
                                  ...prev,
                                  [row.subjectqmescheduleid]: "",
                                }));
                              }}
                            >
                              {(() => {
                                const filteredOptions =
                                  assignMedicareAssistantOptions.filter(
                                    (option: any) =>
                                      (
                                        searchValues[
                                        row.subjectqmescheduleid
                                        ] || ""
                                      )
                                        .toLowerCase()
                                        .trim()
                                        .split(" ")
                                        .every((word) =>
                                          option.label
                                            .toLowerCase()
                                            .includes(word),
                                        ),
                                  );

                                if (filteredOptions.length === 0) {
                                  return (
                                    <div
                                      style={{
                                        fontSize: "13px",
                                        padding: "5px",
                                      }}
                                      className="no_rec_data"
                                    >
                                      No Match Found
                                    </div>
                                  );
                                }

                                return filteredOptions.map((option: any) => (
                                  <Dropdown.Item
                                    key={option.value}
                                    as="label"
                                    active={
                                      option.value === row.medicalAssistant
                                    }
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      handleMedicalAssistantChange(
                                        row,
                                        option.value,
                                      );
                                      setOpenDropdownRowId(null);
                                      setSearchValues((prev) => ({
                                        ...prev,
                                        [row.subjectqmescheduleid]: "",
                                      }));
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name={`medicalAssistant_${row.subjectqmescheduleid}`}
                                      checked={
                                        selectedMedicalAssistants[
                                        row.subjectqmescheduleid
                                        ] === option.value
                                      }
                                      style={{ pointerEvents: "none" }}
                                    />
                                    {option.label}
                                  </Dropdown.Item>
                                ));
                              })()}
                            </DropdownPortal>
                          </>
                       ) : header.key === "locations" ? (
  <span>
    {row.locationCity}, {row.locationZip}
  </span>
) : header.key === "patientName" ? (
  (() => {
    const cellContent = row[header.key];

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
      
        <OverlayTrigger
          placement="auto"
          delay={{ show: 200, hide: 10 }}
          overlay={
            cellContent && cellContent.length > 15 ? (
              <Tooltip
                id={`tooltip-${header.key}-${row.id}`}
                style={{ backgroundColor: "#b3e0ff" }}
              >
                {cellContent}
              </Tooltip>
            ) : (
              <></>
            )
          }
        >
          <span
            className="d-inline-block text-truncate"
            style={{
              cursor: "pointer",
              width: "95%",
              color: "#007bff",
            }}
          >
            <a
              href="#/search-case"
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
              onClick={(e) => {
                e.preventDefault();
                onCaseClick(row);
              }}
            >
              {cellContent}
            </a>
          </span>
        </OverlayTrigger>
          {row.isRushNote === 1 && (
                           <span
  className={`${
    row.isblink === 1
      ? "rushIcon rushiconDashboard"
      : "rushIcon1 rushiconDashboard"
  }`}
  style={{ width: "28px", height: "25px" }}
>
  <span
    className={`material-symbols-outlined rushicon p-1 ${
      row.isblink === 1 ? "heartbeat" : ""
    }`}
    style={{ fontSize: "16px" }}
    onClick={() => onAction?.("openNotes", row)}
  >
    sprint
  </span>
</span>
                          )}
      </div>
    );
  })()
)  : (
                          <OverlayTrigger
                            placement="auto"
                            delay={{ show: 200, hide: 10 }}
                            overlay={
                              cellContent &&
                                cellContent?.length > (isLogTable ? 60 : 15) ? (
                                <Tooltip
                                  id={`tooltip-${header.key}-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  {cellContent}
                                </Tooltip>
                              ) : (
                                <></>
                              )
                            }
                          >
                            <span
                              className={`d-inline-block ${!isLogTable ? "text-truncate" : ""
                                }`}
                              style={{
                                maxWidth: isLogTable ? "none" : "90%",
                                cursor: isLogTable ? "default" : "pointer",
                                color: isStatusColumn
                                  ? getStatusColor(cellContent)
                                  : undefined,
                              }}
                            >
                              {cellContent}
                            </span>
                          </OverlayTrigger>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers?.length} style={{ textAlign: "center" }}>
                  <span className="no_rec_data"> {"No Record Found"}</span>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <SplInstructionsModal
        show={showModal}
        onClose={() => setShowModal(false)}
        data={instructionsData}
        position={modalPos}
      />
    </>
  );
};

export default AppointmentDataTable;
